module.exports = __webpack_public_path__ + "img/download.7d8684.svg";